<template>
  <div id="app">
    <Header/>
    <SearchForm v-on:search="search"/>
    <SearchResults
      v-if="videos.length > 0"
      v-bind:videos="videos"
      v-bind:reformattedSearchString="reformattedSearchString"
      v-bind:placeKey="placeKey"
      v-bind:roomNo="roomNo"
    />
  </div>
</template>

<script>
import Header from './components/layout/Header';
import SearchForm from './components/SearchForm';
import SearchResults from './components/SearchResults';
import wx from "weixin-js-sdk";
import axios from 'axios';

export default {
  name: 'app',
  components: {
    Header,
    SearchForm,
    SearchResults
  },
  data() {
    return {
      videos: [],
      reformattedSearchString: '',
      placeKey: '',
      roomNo: '',
      appId: 'wx20abaf12457bc818',
      wechatSdkUrl: 'https://xmsong.echoktv.net/api/page/weixin/getJsSdk?url=',
      api: {
        //baseUrl: 'https://youtu.echoktv.net/ytb/?', //新加坡服务器
        baseUrl: 'https://mlyt.goodtimektv.com/ytb/?',
        part: 'snippet',
        type: 'video',
        order: 'viewCount',
        maxResults: 12,
        q: '',
        prevPageToken: '',
        nextPageToken: ''
      }
    };
  },

  mounted: function () {
    // this.weChatSdk(); web分布式部署取消
  },

  methods: {
    async search(searchParams) {
      this.getUrlPram();
      this.reformattedSearchString = searchParams.join(' ');
      this.api.q = searchParams.join('+');
      const {baseUrl, part, type, order, maxResults, q} = this.api;
      //const apiUrl = `${baseUrl}part=${part}&type=${type}&order=${order}&queryString=${q}&maxResults=${maxResults}`;
      const apiUrl = `${baseUrl}q=${q}`;
      this.getData(apiUrl);
    },

    async getData(apiUrl) {
      await axios
          .get(apiUrl)
          .then(res => {
            this.videos = res.data.data.items;
          })
          .catch(error => console.log(error));
    },

    getUrlPram() {
      let geturl = window.location.href;
      let getqyinfo = geturl.split('?')[1];
      let getqys = new URLSearchParams(getqyinfo);
      this.placeKey = getqys.get('placeKey');
      this.roomNo = getqys.get('roomNo');
    },

    weChatSdk() {
      //const wx_host = encodeURIComponent(window.location.href);
      const wx_host = window.location.href.split('?')[0];
      const param = window.location.href.split('?')[1];
      let apiUrl = `https://xmsong.echoktv.net/api/weixin/getJsSdk`;
      let data = {"url":wx_host,"param1":param.split('&')[0],"param2":param.split('&')[1]};
      axios
          .post(apiUrl,data)
          .then(result => {
            this.videos = result.data.data.items;
            if(result.data.code == 200) {
              const config = {
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: this.appId, // 必填，公众号的唯一标识
                timestamp: result.data.data.timestamp, // 必填，生成签名的时间戳
                nonceStr: result.data.data.nonceStr, // 必填，生成签名的随机串
                signature: result.data.data.signature, // 必填，签名
                jsApiList: result.data.data.jsApiList, // 必填，需要使用的JS接口列表，注意查看官方文档，部分js接口即将废弃，我这里用的是新的
              };
              wx.config(config); //通过config接口注入权限验证配置
              //通过ready接口处理成功验证
              wx.ready(function(){
                wx.checkJsApi({
                  jsApiList: result.data.data.jsApiList,
                  success: function (res) {
                    console.log("checkjsApi_success:"+JSON.stringify(res));
                  }
                });
                wx.hideAllNonBaseMenuItem();
              });
              wx.error(function (res) {
                // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                console.info('config信息验证失败');
                console.info(res);
                //return reject(false);
              });
            }
          })
          .catch(error => console.log(error));
    },

  }
}
;
</script>
